'use strict';
var SurveyController = function ($state, $element, previousState, ssWidgetService, $scope, authToken, customerModelService, SettingsConstants) {

    $scope.ssWidgetReady = false;

    var serviceId = $state.params.serviceId;
    var templateId = $state.params.templateId;
    var services = customerModelService.getCustomerConcernsServices();
    var service = services.find(function (el) { return el.id.toString() === serviceId});

    var existingSurvey = service.survey;
    var surveysList = ssWidgetService.getAvailableSurveyTemplates();
    var currentSurvey = surveysList.find(function (el) { return el.id === templateId });
    var link = currentSurvey.link;
    var callback = currentSurvey.callback;

    var surveyContent = { serviceId: service.id, link: link, callback: callback };
    var promise;

    var container = document.getElementById('ssWidgetContainer');

    if (existingSurvey) {
        var surveyId = existingSurvey.link.split('/').pop();
        promise = ssWidgetService.loadWidget(container, templateId + "/" + surveyId, surveyContent)
    } else {
        promise = ssWidgetService.loadWidget(container, templateId, surveyContent)
    }

    promise.then(function () {
        $scope.ssWidgetReady = true;
        $scope.$applyAsync();
    });

    function goBack() {
        ssWidgetService.destroy();
        $state.go(previousState.name || SettingsConstants.APP_DEFAULT_STATE, previousState.params || {});
    }

    ssWidgetService.onSurveySave(function() {
        customerModelService.resolveSurveyServices([service])
            .then(function () {})
            .finally((function () {
                goBack();
            }))
    });

    ssWidgetService.onSurveyCancel(function () {
        goBack();
    });

    $scope.$on('$destroy', function() {
        ssWidgetService.destroy();
    });
};

SurveyController.$inject = ['$state', '$element', 'previousState', 'ssWidgetService', '$scope', 'authToken', 'customerModelService', 'SettingsConstants'];

module.exports = SurveyController;
